import { Mount, SensorType, ProductSubCategoryEnum, ProductTypeEnum, ProductUsageEnum } from "@shared/enums";
import { ProductSlimResponseDTO, ProductSlimInclude, ProductSlimQueryOptions } from "@shared/DTO";
import { PurchaseVariantOption } from "@/scripts/components/purchase-cta/purchaseCta.model";

export const PRODUCT_DISPLAYS = ["grid", "slider"] as const;
export type ProductDisplay = typeof PRODUCT_DISPLAYS[number];
export const PRODUCT_FILTER_TAGS = ["ab-filter-brand", "ab-filter-product-type", "ab-filter-sensor-format", "ab-filter-lens-compatibility",
  "ab-filter-target", "ab-filter-sub-category", "ab-filter-usage"] as const;
export type ProductFilterTag = typeof PRODUCT_FILTER_TAGS[number];

export interface ProductListingConfig {
  source: string;
  include?: ProductSlimInclude;
  composition: { productIds: readonly string[] };
  display: ProductDisplay;
  filters: readonly ProductFilterTag[];
}

export interface ProductListingSelections {
  brands: readonly string[];
  productTypes: readonly ProductTypeEnum[];
  sensorFormats: readonly SensorType[];
  compatibleLensMounts: readonly Mount[];
  targets: readonly number[];
  subCategories: readonly ProductSubCategoryEnum[];
  usages: readonly ProductUsageEnum[];
}

export type ProductListingStatus = "idle" | "loading" | "ready" | "empty" | "error";

export interface ProductListingState {
  status: ProductListingStatus;
  sourceProducts: ReadonlyArray<ProductSlimResponseDTO>;
  composedItems: ReadonlyArray<ProductListingItem>;
  visibleItems: ReadonlyArray<ProductListingItem>;
  selections: ProductListingSelections;
  error?: unknown;
}

export type LensMountPurchaseOption = PurchaseVariantOption;

export type ProductPurchaseOptions =
  | { type: "default"; url?: string }
  | { type: "lensMounts"; options: readonly LensMountPurchaseOption[] };

export interface ProductListingItem {
  product: ProductSlimResponseDTO;
  purchaseOptions: ProductPurchaseOptions;
}

export interface ProductSlimRepository {
  getProductSlim(source: string, options?: ProductSlimQueryOptions): Promise<ProductSlimResponseDTO[]>;
}
